const binding = { modules: {}, dataActions: {} };

    (binding.modules['cus-recommended-products'] = {
        c: () => require('partner/modules/cus-recommended-products/cus-recommended-products.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'cus-recommended-products',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/cus-recommended-products'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };